<div class="seccionA">
        <h4 class="Ftitle">{{titulo}}</h4>
        <label class="Fsubtitle">{{subtitulo}}</label>
    </div>